/*
  Gaia Iluka — sitewide welcome / chef's-note modal, auto-open-once trigger
  File: assets/gi-welcome-modal.js

  Everything about SHOWING and HIDING the dialog itself — backdrop, focus
  trap, Escape, click-outside, scroll lock, open/close animation — already
  exists in assets/dialog.js's <dialog-component> (the same engine
  snippets/search-modal.liquid and blocks/popup-link.liquid use). This
  file's only job is deciding WHEN to call that dialog's own showDialog(),
  and remembering that it already ran. No scroll listening, no rAF loop —
  this is not the same class of script as the scroll-scrubbed sections
  elsewhere in this theme.

  ONCE PER VISIT: sessionStorage, not localStorage — reappears in a new
  tab or after the browser restarts. Matches this exact codebase's own
  existing precedent for "once per session" (gi_page_loaded_once,
  layout/theme.liquid:9-19,533) rather than introducing a new permanent-
  storage convention for a single component.

  TIMING: the page loader (layout/theme.liquid) hides itself ~350ms after
  DOMContentLoaded (with a 3s hard cap as a safety net — see that file's
  own comment). This waits slightly longer than that so the modal doesn't
  visibly compete with the loader for the screen.

  THEME EDITOR: mirrors the editor-bypass spirit of oncePerEditorSession()
  in assets/utilities.js — while a merchant is actively editing THIS
  section in the customizer (shopify:section:load fires with this
  section's markup as the target), the modal force-shows regardless of
  the stored flag, so edits are always visible without needing to clear
  storage. It does not touch the stored flag in that case, so real-visitor
  behavior is unaffected by editor use.
*/
(function () {
  'use strict';

  var DIALOG_SELECTOR = '#GiWelcomeModal';
  var STORAGE_KEY = 'gi_welcome_seen';
  var OPEN_DELAY_MS = 450;

  var shown = false;

  function hasBeenSeen() {
    try {
      return sessionStorage.getItem(STORAGE_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function markSeen() {
    try {
      sessionStorage.setItem(STORAGE_KEY, '1');
    } catch (e) {
      // Storage unavailable (private mode, quota, etc.) — the modal will
      // simply be able to reopen; not worth failing louder than that.
    }
  }

  function openDialog(el) {
    if (!el || typeof el.showDialog !== 'function') return;
    shown = true;
    el.showDialog();
    el.addEventListener('dialog:close', markSeen, { once: true });
  }

  function isInThemeEditor() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  function triggerAutoOpen() {
    if (shown) return;
    var el = document.querySelector(DIALOG_SELECTOR);
    if (!el) return;
    if (!isInThemeEditor() && hasBeenSeen()) return;

    if (typeof customElements !== 'undefined' && customElements.whenDefined) {
      customElements.whenDefined('dialog-component').then(function () {
        openDialog(el);
      });
    } else {
      openDialog(el);
    }
  }

  function scheduleAutoOpen() {
    setTimeout(triggerAutoOpen, OPEN_DELAY_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleAutoOpen);
  } else {
    scheduleAutoOpen();
  }

  // Theme editor: force-show while this specific section is the one being
  // loaded (added or actively edited), without consulting or touching the
  // stored "seen" flag.
  document.addEventListener('shopify:section:load', function (evt) {
    if (!isInThemeEditor()) return;
    var root = evt.target;
    if (!root || !root.querySelector) return;
    var el = root.querySelector(DIALOG_SELECTOR);
    if (!el) return;
    shown = false;
    if (typeof customElements !== 'undefined' && customElements.whenDefined) {
      customElements.whenDefined('dialog-component').then(function () {
        openDialog(el);
      });
    } else {
      openDialog(el);
    }
  });
})();
